import React, { useEffect, useContext, useState, useActionState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Building from '../../Assets/Icons/Icon_Building.png';
import Icon_Floor from '../../Assets/Icons/Icon_Floor.png';
import Icon_Room from '../../Assets/Icons/Icon_Room.png';
import Icon_Color_ImageNotFound from '../../Assets/Icons/Icon_Color_ImageNotFound.png';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import { Buildings_Add } from '../../api/API_Buildings';
import { Floors_Add, Floors_Upload_Image } from '../../api/API_Floors';
import { Rooms_Add } from '../../api/API_Rooms';
import { useMapEditor } from '../../Contexts/Context_MapEditor';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import UI_Button from '../ERUMAUI/UI_Button';

export default function Subwindow_MapEditor_Add({ zIndex, isActive, id }) {
    const UI = useContext(Context_UI);
    const { Update } = useMapEditor();
    const [ID_ActiveDropdown, ID_ActiveDropdown_Set] = useState(null);
    const [ID_ActiveForm, ID_ActiveForm_Set] = useState("Building");
    const { Version, Buildings, Floors, Refresh, Composition_Build, Window_ActiveTab, Window_ActiveTab_Set, Building_Update, Floor_Update } = useMapEditor();
    const [Image_Source, Image_Source_Set] = useState(null);
    const [Floor_Name_Suggestion, Floor_Name_Suggestion_Set] = useState(null);
    const [Floor_Name_Suggestion_Lock, Floor_Name_Suggestion_Lock_Set] = useState(null);
    const [Floor_Building, Floor_Building_Set] = useState(null);
    const [Room_Building, Room_Building_Set] = useState(null);
    const [Room_Floor, Room_Floor_Set] = useState(null);
    const [Room_Floor_List, Room_Floor_List_Set] = useState([]);
    const { Template_List } = useTemplating();
    const { Status_Refresh_Set, Status_Fetching_Set, Status_Saving_Set } = useStatus();
    const [Room_Type, Room_Type_Set] = useState(null);
    const Navigate = useNavigate();
    const Close = () => {
        UI.Subwindows_Close(id);
        Navigate("/map/edit")
        // UI.Subwindows_Open("Window_Register_Success");
    }

    useEffect(() => {
        const OnListSelect = ({ List_ID, Value, Value_Index }) => {
            ID_ActiveDropdown_Set(List_ID);
            if (List_ID == "MapEditor_Form_Type") {
                // ID_ActiveForm_Set(Value);
                Window_ActiveTab_Set(Value);
            }
            if (List_ID == "MapEditor_Floor_Building") {
                Floor_Building_Set(Value);
            }
            if (List_ID == "MapEditor_Room_Building") {
                Room_Building_Set(Value);
                Room_Floor_Set(null);
            }
            if (List_ID == "MapEditor_Room_Floor") {
                Room_Floor_Set(Value);
            }
            if (List_ID == "MapEditor_Room_Type") {
                Room_Type_Set(Template_List.RoomType[Value_Index]);
                // console.warn(Template_List.RoomType[Value_Index]);
            }
        }
        UI.on("Dropdown_Value_Submitted", OnListSelect);

        const OnTabSelect = ({ ID, Tab_Active }) => {
            // ID_ActiveDropdown_Set(List_ID);
            if (ID == "MapEditor_Form_Type_Tabs") {
                // console.log(`Switched to ${Tab_Active}`);
                ID_ActiveForm_Set(Tab_Active);
                Window_ActiveTab_Set(Tab_Active);
            }
        }
        UI.on("Tabs_Horizontal_Switched", OnTabSelect);
        return () => {
            UI.off("Dropdown_Value_Submitted", OnListSelect);
            UI.off("Tabs_Horizontal_Switched", OnTabSelect);
        }



    }, []);

    useEffect(() => {
        if (Room_Building) {
            const Building = Buildings.find(Building => Building.Name === Room_Building);
            if (Building) {
                const floorsForBuilding = Floors
                    .filter(Floor => Floor.Building === Building._id)
                    .map(Floor => Floor.Name);
                Room_Floor_List_Set(floorsForBuilding);
            }
        } else {
            Room_Floor_List_Set([]);
        }
    }, [Room_Building, Buildings, Floors])

    useEffect(() => {
        ID_ActiveForm_Set(Window_ActiveTab);
    })

    useEffect(() => {
        const el = document.getElementById(id);
        if (el) {
            el.setAttribute("Visibility", "Open");
            el.setAttribute("State", isActive ? "Active" : "Inactive");
            el.style.zIndex = zIndex;
        }
    }, [zIndex, isActive]);

    const Building_List = Buildings.slice().map(Building => (Building.Name));

    const Submit = () => {
        console.warn(ID_ActiveForm);
        switch (ID_ActiveForm) {
            case "Tab_Building":
                Submit_Building();
                break;
            case "Tab_Floor":
                Submit_Floor();
                break;
            case "Tab_Room":
                Submit_Room();
                break;
        }
    }

    const Submit_Building = async () => {
        let Evaluation_Verdict = await UI.Input_Evaluate([
            {
                Type: "Text",
                ID: "MapEditor_Building",
                AC: ""
            },
            {
                Type: "Text",
                ID: "MapEditor_Building_Address",
                AC: ""
            }
        ]);

        if (Evaluation_Verdict == true) {
            Status_Saving_Set("InProgress");
            try {
                await Buildings_Add({
                    Name: UI.Element_Value_Get("MapEditor_Building"),
                    Address: UI.Element_Value_Get("MapEditor_Building_Address"),
                    Floors: []
                });
                Refresh();
                UI.Element_Value_Set("MapEditor_Building", "");
                UI.Element_Value_Set("MapEditor_Building_Address", "");
                window.Toasts_CreateToast("https://elmerf5445.github.io/Digi-Rooms-Status/Assets/Icons/favicon.png", "Building created", "Refresh this page to see the latest information.");
                Status_Saving_Set("Success");
            } catch (Error) {
                console.error(Error);
                Status_Saving_Set("Error");
            }

        }
    }

    const Submit_Floor = async () => {
        let Evaluation_Verdict = await UI.Input_Evaluate([
            {
                Type: "Dropdown",
                ID: "MapEditor_Floor_Building",
                AC: "Select a building"
            },
            {
                Type: "Text",
                ID: "MapEditor_Floor_Number",
                AC: ""
            },
            {
                Type: "Text",
                ID: "MapEditor_Floor_Name",
                AC: ""
            },
            {
                Type: "Text",
                ID: "MapEditor_Floor_Plan_URL",
                AC: ""
            }
        ]);

        if (Evaluation_Verdict == true) {
            try {
                Status_Saving_Set("InProgress");
                let Building = Buildings.find(Building => Building.Name === Floor_Building);
                const Floor = await Floors_Add({
                    Building: Building._id,
                    Number: UI.Element_Value_Get("MapEditor_Floor_Number"),
                    Name: UI.Element_Value_Get("MapEditor_Floor_Name"),
                    Plan: {
                        FileName: "Test",
                        // FileURL: UI.Element_Value_Get("MapEditor_Floor_Plan_URL"),
                        FileURL: Floor_Plan_URL,
                        FileType: "Foreign upload",
                        FileDateModified: new Date()
                    }
                });
                const Floor_New = Floor.data;
                if (!Floor_New || !Floor_New._id) {
                    throw new Error("No returned ID");
                }
                const Floors = [...(Building.Floors || []), Floor_New._id];
                await Building_Update(Building._id, { Floors: Floors });
                Refresh();
                window.Toasts_CreateToast("https://elmerf5445.github.io/Digi-Rooms-Status/Assets/Icons/favicon.png", "Floor created", "Refresh this page to see the latest information.");
                Status_Saving_Set("Success");
            } catch (Error) {
                console.error(Error);
                Status_Saving_Set("Error");
            }
        }

    }

    const Submit_Room = async () => {
        let Evaluation_Verdict = await UI.Input_Evaluate([
            {
                Type: "Dropdown",
                ID: "MapEditor_Room_Building",
                AC: "Pick a building"
            },
            {
                Type: "Dropdown",
                ID: "MapEditor_Room_Floor",
                AC: "Pick a floor"
            },
            {
                Type: "Text",
                ID: "MapEditor_Room_Name",
                AC: ""
            },
            {
                Type: "Text",
                ID: "MapEditor_Room_Capacity",
                AC: ""
            },
            {
                Type: "Text",
                ID: "MapEditor_Room_Code",
                AC: ""
            },
            {
                Type: "Dropdown",
                ID: "MapEditor_Room_Type",
                AC: "Pick a room type"
            }
        ]);

        if (Evaluation_Verdict !== true) return;

        try {
            Status_Saving_Set("InProgress");

            // Find building by name from dropdown
            const Building = Buildings.find(Building => Building.Name === Room_Building);
            if (!Building) throw new Error("Building not found");

            // Find floor by name from dropdown
            const Floor = Floors.find(Floor => Floor.Name === Room_Floor && Floor.Building === Building._id);
            if (!Floor) throw new Error("Floor not found");

            let Payload_Restrictions = {
                hasBlockedHours: false,
                Blocked_Hours: {}
            }

            // console.log(Room_Type);
            if (Room_Type !== null) {
                Payload_Restrictions = {
                    hasBlockedHours: Room_Type.hasDefinedHours,
                    BlockedHours: Room_Type.DefinedHours.map(day => ({
                        Day: day.Day,
                        Block: day.hasDefinedHours,
                        Start: day.Start,
                        End: day.End
                    }))
                }
            }

            let Payload = {
                Name: UI.Element_Value_Get("MapEditor_Room_Name"),
                Capacity: Number(UI.Element_Value_Get("MapEditor_Room_Capacity")),
                // Capacity: 0,
                Type: document.getElementById("MapEditor_Room_Type").querySelector(".Dropdown_Button").querySelector(".Dropdown_Button_Text").innerText,
                Location: {
                    Building: Building._id,
                    Floor: Floor._id,
                    Code: UI.Element_Value_Get("MapEditor_Room_Code"),
                    Coordinates: {
                        X: "100",
                        Y: "100"
                    }
                },
                Restrictions: Payload_Restrictions
            }
            // console.log(Payload_Restrictions);
            // console.log(Payload);

            // Create the room in the Rooms collection
            const Room_New = await Rooms_Add(Payload);

            if (!Room_New?.data?._id) throw new Error("Room creation failed — no ID returned");

            const UpdatedRooms = [...(Floor.Rooms || []), Room_New.data._id];
            await Floor_Update(Floor._id, { Rooms: UpdatedRooms });

            UI.Element_Value_Set("MapEditor_Room_Name", "");
            // UI.Element_Value_Set("MapEditor_Room_Capacity", "");
            UI.Element_Value_Set("MapEditor_Room_Code", "");

            Refresh();
            window.Toasts_CreateToast(
                "https://elmerf5445.github.io/Digi-Rooms-Status/Assets/Icons/favicon.png",
                "Room created",
                "Refresh this page to see the latest information."
            );
            Status_Saving_Set("Success");

        } catch (Error) {
            console.error(Error);
            Status_Saving_Set("Error");
        }
    };



    const Handle_Image = () => {
        if (UI.Element_Value_Get("MapEditor_Floor_Plan_URL")) {
            Image_Source_Set(UI.Element_Value_Get("MapEditor_Floor_Plan_URL"));
        }

    }

    const Handle_Autofill = () => {
        if (UI.Element_Value_Get("MapEditor_Floor_Number")) {
            Floor_Name_Suggestion_Lock_Set(true);
            Floor_Name_Suggestion_Set(`Floor ${UI.Element_Value_Get("MapEditor_Floor_Number")}`);
            Floor_Name_Suggestion_Lock_Set(false);
        }
    }

    const Format_Time = (dateTemp, Type) => {
        const date = new Date(dateTemp);
        if (!(date instanceof Date) || isNaN(date)) return "?";
        const pad = (n) => String(n).padStart(2, "0");
        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());

        switch (Type) {
            case "date":
                return `${year}-${month}-${day}`;
            case "time":
                return `${hours}:${minutes}`;
            case "datetime-local":
                return `${year}-${month}-${day}T${hours}:${minutes}`;
            default:
                return "";
        }
    }

    const Handle_Change = async (Event, Index, Side) => {
        // console.log(Event.target.value);
        const Verdict = await UI.Input_Evaluate([
            {
                Type: "Time_Range",
                ID_Start: `BlockedDay_${Index}_Start`,
                ID_End: `BlockedDay_${Index}_End`,
                AC: "Past",
                Prompt: "Invalid time"
            }
        ]);
        const Room_Type_Updated = { ...Room_Type };
        const Value = new Date(`2025-10-15T${Event.target.value}`);
        if (Side === "Start") {
            Room_Type_Updated.DefinedHours[Index].Start = Value;
        } else if (Side === "End") {
            Room_Type_Updated.DefinedHours[Index].End = Value;
        }

        Room_Type_Set(Room_Type_Updated);
    }

    useEffect(() => {
        const Handle_Toggle_BlockedDay = ({ ID, State }) => {
            const Index = ID.split("_")[1];
            // console.log(State);
            Handle_Toggle(Index, State);
        }
        UI.on("Button_Toggled", Handle_Toggle_BlockedDay);
        return () => {
            UI.off("Button_Toggled", Handle_Toggle_BlockedDay)
        };
    });

    const Handle_Toggle = (Index, State) => {
        const Room_Type_Updated = { ...Room_Type };
        let State_New = false;
        if (State === "Active") {
            State_New = true;
        } else {
            State_New = false;
        }
        Room_Type_Updated.DefinedHours[Index].hasDefinedHours = State_New;
        Room_Type_Set(Room_Type_Updated);
    }
    const [Floor_Plan_File, Floor_Plan_File_Set] = useState(null);
    const [Floor_Plan_URL, Floor_Plan_URL_Set] = useState("");

    const Handle_File_Change = (e) => {
        Floor_Plan_File_Set(e.target.files[0]);
    };

    const Handle_File_Upload = async () => {
        if (!Floor_Plan_File) return;
        try {
            const formData = new FormData();
            formData.append("image", Floor_Plan_File);

            const result = await Floors_Upload_Image(formData);

            Floor_Plan_URL_Set(result.data.imageUrl);
            UI.Element_Value_Set("MapEditor_Floor_Plan_URL", result.data.imageUrl);

            // console.log("UPLOAD RESULT:", result.data);
            Handle_Image();
        } catch {
            UI.Element_Value_Set("MapEditor_Floor_Plan_URL", "Error. Try again.");
        }
        
    };

    return (
        <ui-subwindow Type='Subwindow' id={id} State='Inactive' Visibility='Close'>
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Add item
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Close}>
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content style={{ minHeight: "500px", paddingRight: "10px" }}>
                <p className='General_Paragraph'>
                    Choose an item to add below.
                </p>
                <UI_Horizontal_Tabs Selectors={[
                    {
                        Text: "Building",
                        Icon: Icon_Building
                    },
                    {
                        Text: "Floor",
                        Icon: Icon_Floor
                    },
                    {
                        Text: "Room",
                        Icon: Icon_Room
                    }
                ]}
                    Selected={Window_ActiveTab}
                    id="MapEditor_Form_Type_Tabs"
                    UIDs={[
                        "Building",
                        "Floor",
                        "Room"
                    ]}
                    Components={[
                        <>
                            <h3 className='General_Paragraph'>
                                Add a new building
                            </h3>
                            <UI_Form id="MapEditor_Form_Building" Composition="ByTwo">
                                <UI_Input_Text Label_Text="Building name:" Type="text" Input_Placeholder="Enter building name" id="MapEditor_Building" Required={true} />
                                <UI_Input_Text Label_Text="Building address:" Type="text" Input_Placeholder="Enter building address" id="MapEditor_Building_Address"
                                    Required={true}
                                />
                            </UI_Form>
                        </>,
                        <>
                            <h3 className='General_Paragraph'>
                                Add a new floor
                            </h3>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                <UI_Form id="MapEditor_Form_Floor" Composition="ByTwo">
                                    <label className="Input_Label" for="MapEditor_Floor_Building">
                                        Building:
                                        <p className="Input_Label_Required">*</p>
                                    </label>
                                    <UI_Dropdown InitialTitle="Select a building" id="MapEditor_Floor_Building" Items={Building_List} />
                                    <UI_Input_Text Label_Text="Floor number:" Input_Type="number" Input_Placeholder="(e.g. 1, 2, 3, etc.)" id="MapEditor_Floor_Number" Required={true} min={1} max={999} />
                                    <UI_Input_Text Label_Text="Floor name:" Input_Type="text" Input_Placeholder="(e.g. Floor 1, Floor 2, Floor 3, etc.)" id="MapEditor_Floor_Name" Required={true} />
                                    <UI_Input_Text Label_Text="Floor plan URL:" Type="text" Input_Placeholder="Enter a valid, usable link." id="MapEditor_Floor_Plan_URL" onInput={Handle_Image} Required={true} />
                                    <input 
                                        type="file"
                                        onChange={Handle_File_Change}
                                        accept="image/png, image/jpeg, image/svg, image/svg+xml"
                                    />
                                    <UI_Button
                                        Text="Upload new floor plan"
                                        OnClick={Handle_File_Upload}
                                    />
                                </UI_Form>
                                {
                                    Image_Source ?
                                        <div>
                                            <p className='General_Paragraph'>
                                                Map preview:
                                            </p>
                                            <img src={Image_Source} style={{ width: "100%", height: "100%", objectFit: "contain" }} onError={() => Image_Source_Set(null)} />
                                        </div>

                                        :
                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                            <img src={Icon_Color_ImageNotFound} draggable="false" loading='lazy' style={{ width: "150px" }} />
                                            <h3 className='General_Paragraph'>
                                                Image not loaded.
                                            </h3>
                                            <p className='General_Paragraph'>
                                                Either the link you entered can't be accessed or its field is empty.
                                            </p>
                                        </div>

                                }
                            </div>
                        </>,
                        <>
                            <h3 className='General_Paragraph'>
                                Add a new room
                            </h3>
                            <UI_Form id="MapEditor_Form_Room" Composition="ByTwo">
                                <div style={{ display: "grid", gridTemplateColumns: "90px 1fr 90px 1fr", gap: "10px", alignItems: "center" }} Override_Form_Composition="Override">
                                    <label className="Input_Label" for="MapEditor_Room_Building">
                                        Building:
                                        <p className="Input_Label_Required">*</p>
                                    </label>
                                    <UI_Dropdown id="MapEditor_Room_Building" InitialTitle="Pick a building" Items={Building_List} Fill />

                                    <label className="Input_Label" for="MapEditor_Room_Floor">
                                        Floor:
                                        <p className="Input_Label_Required">*</p>
                                    </label>
                                    <UI_Dropdown id="MapEditor_Room_Floor" InitialTitle="Pick a floor" Items={Room_Floor_List} Fill />
                                </div>


                                <UI_Input_Text Label_Text="Room name:" Type="text" Input_Placeholder="Room name" id="MapEditor_Room_Name" Required={true} />
                                <UI_Input_Text Label_Text="Capacity:" Input_Type="number" Input_Placeholder="Set capacity" id="MapEditor_Room_Capacity" Required={true} min={1} max={ 9999} />
                                <UI_Input_Text Label_Text="Room code:" Input_Type="number" Input_Placeholder="(e.g., 101, 102, 103, etc.)" id="MapEditor_Room_Code" Required={true} />
                                <label className="Input_Label" for="MapEditor_Room_Type">
                                    Room type:
                                    <p className="Input_Label_Required">*</p>
                                </label>
                                <UI_Dropdown id="MapEditor_Room_Type" InitialTitle="Pick a room type" Items={Template_List?.RoomType?.map(Item => Item.Name)} Fill
                                    Selected={Room_Type?.Name} />
                            </UI_Form>
                            {Room_Type?.hasDefinedHours ?
                                <>
                                    <UI_Divider Text="Define class hours" />
                                    <p className='General_Paragraph'>
                                        This room type has defined class hours. You can customize the class hours below. If a reservation conflicts with this room's class hours, the system will warn them.
                                    </p>
                                    <table className='TP_BlockedHours'>
                                        <thead>
                                            <tr>
                                                <td>
                                                    <p className='General_Paragraph'>
                                                        Day
                                                    </p>
                                                </td>
                                                <td>
                                                    <p className='General_Paragraph'>
                                                        Has blocked hours?
                                                    </p>
                                                </td>
                                                <td>
                                                    <p className='General_Paragraph'>
                                                        Start time
                                                    </p>
                                                </td>
                                                <td>
                                                    <p className='General_Paragraph'>
                                                        End time
                                                    </p>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Room_Type.DefinedHours.map((Item, Index) => (
                                                <tr>
                                                    <td>
                                                        <p className='General_Paragraph'>
                                                            {Item.Day}
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <UI_Toggle
                                                            Text="Has blocked hours"
                                                            id={`BlockedDay_${Index}`}
                                                            Type="Switch"
                                                            Selected={Item.hasDefinedHours ? "true" : "false"}
                                                        />
                                                    </td>
                                                    <td>
                                                        {Item.hasDefinedHours ?
                                                            <UI_Input_Text
                                                                id={`BlockedDay_${Index}_Start`}
                                                                Input_Type='time'
                                                                Value={Format_Time(Item.Start, "time")}
                                                                onChange={(Event) => Handle_Change(Event, Index, "Start")}
                                                            />
                                                            :
                                                            <p className='General_Paragraph'>
                                                                Free all day
                                                            </p>
                                                        }

                                                    </td>
                                                    <td>
                                                        {Item.hasDefinedHours ?
                                                            <UI_Input_Text
                                                                id={`BlockedDay_${Index}_End`}
                                                                Input_Type='time'
                                                                Value={Format_Time(Item.End, "time")}
                                                                onChange={(Event) => Handle_Change(Event, Index, "End")}
                                                            />
                                                            :
                                                            <p className='General_Paragraph'>
                                                                -
                                                            </p>
                                                        }
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                                :
                                ""
                            }
                        </>
                    ]} />
                {/* <UI_Dropdown InitialTitle={Window_ActiveTab} id="MapEditor_Form_Type" Items={[
                    "Building",
                    "Floor",
                    "Room"
                ]} />
                {
                    ID_ActiveForm == "Building" ?
                        <>
                            <h3 className='General_Paragraph'>
                                Add a new building
                            </h3>
                            <UI_Form id="MapEditor_Form_Building" Composition="ByTwo">
                                <UI_Input_Text Label_Text="Building name:" Type="text" Input_Placeholder="Enter building name" id="MapEditor_Building" />
                                <UI_Input_Text Label_Text="Building address:" Type="text" Input_Placeholder="Enter building address" id="MapEditor_Building_Address" />
                            </UI_Form>
                        </>
                        :
                        <>
                            {
                                ID_ActiveForm == "Floor" ?
                                    <>
                                        <h3 className='General_Paragraph'>
                                            Add a new room
                                        </h3>
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                                            <UI_Form id="MapEditor_Form_Floor" Composition="ByTwo">
                                                <label className="Input_Label" for="MapEditor_Floor_Building">
                                                    Building:
                                                </label>
                                                <UI_Dropdown InitialTitle="Select a building" id="MapEditor_Floor_Building" Items={Building_List} />
                                                <UI_Input_Text Label_Text="Floor number:" Input_Type="number" Input_Placeholder="(e.g. 1, 2, 3, etc.)" id="MapEditor_Floor_Number" />
                                                <UI_Input_Text Label_Text="Floor name:" Input_Type="text" Input_Placeholder="(e.g. Floor 1, Floor 2, Floor 3, etc.)" id="MapEditor_Floor_Name" />
                                                <UI_Input_Text Label_Text="Floor plan URL:" Type="text" Input_Placeholder="Enter a valid, usable link." id="MapEditor_Floor_Plan_URL" onInput={Handle_Image} />
                                            </UI_Form>
                                            {
                                                Image_Source ?
                                                    <div>
                                                        <p className='General_Paragraph'>
                                                            Map preview:
                                                        </p>
                                                        <img src={Image_Source} style={{ width: "100%", height: "100%", objectFit: "contain" }} onError={() => Image_Source_Set(null)} />
                                                    </div>

                                                    :
                                                    <p className='General_Paragraph'>
                                                        No image is loaded. Either the link you entered can't be accessed or its field is empty.
                                                    </p>
                                            }
                                        </div>
                                    </>
                                    :
                                    <>
                                        <h3 className='General_Paragraph'>
                                            Add a new room
                                        </h3>
                                        <UI_Form id="MapEditor_Form_Room" Composition="ByTwo">
                                            <div style={{ display: "grid", gridTemplateColumns: "90px 1fr 90px 1fr", gap: "10px", alignItems: "center" }} Override_Form_Composition="Override">
                                                <label className="Input_Label" for="MapEditor_Room_Building">
                                                    Building:
                                                </label>
                                                <UI_Dropdown id="MapEditor_Room_Building" InitialTitle="Pick a building" Items={Building_List} Fill />

                                                <label className="Input_Label" for="MapEditor_Room_Floor">
                                                    Floor:
                                                </label>
                                                <UI_Dropdown id="MapEditor_Room_Floor" InitialTitle="Pick a floor" Items={Room_Floor_List} Fill />
                                            </div>


                                            <UI_Input_Text Label_Text="Room name:" Type="text" Input_Placeholder="Room name" id="MapEditor_Room_Name" />
                                            <UI_Input_Text Label_Text="Capacity:" Input_Type="number" Input_Placeholder="Set capacity" id="MapEditor_Room_Capacity" />
                                            <UI_Input_Text Label_Text="Room code:" Input_Type="number" Input_Placeholder="(e.g., 101, 102, 103, etc.)" id="MapEditor_Room_Code" />
                                            <label className="Input_Label" for="MapEditor_Room_Type">
                                                Room type:
                                            </label>
                                            <UI_Dropdown id="MapEditor_Room_Type" InitialTitle="Pick a room type" Items={Template_List.RoomType} Fill />
                                        </UI_Form>
                                    </>
                            }
                        </>
                } */}

            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Close}>
                    Close
                </button>
                <button className='General_Button Subwindow_Control' Type='Primary' onClick={Submit}>
                    Add item
                </button>
            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
